// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","header-logo":"Header_header-logo__dfVwh"};